import axios from 'axios';
import baseUrl from '../constants/baseURL';
import requests from '../constants/requestURL';
import { toast } from 'react-hot-toast';
import { store } from '../store';
import { startLoading, stopLoading } from '../store/loadingSlice';
import { logoutUser } from '../store/userSlice';

const handleTokenValidation = (token: string): boolean => {
  try {
    if (!token) return false;

    const base64Payload = token.split('.')[1];
    const decodedPayload = JSON.parse(atob(base64Payload));

    if (!decodedPayload.exp) {
      console.error('Token is missing the "exp" claim');
      return false;
    }

    const currentTimestamp = Date.now();

    console.log('decodedPayload.exp', decodedPayload.exp);

    if (decodedPayload.exp > currentTimestamp) {
      return true;
    } else {
      return false;
    }

    return true;
  } catch (error) {
    console.error('Failed to validate token:', error);
    return false;
  }
};

// const validateToken = (token: string) => {
//   if (!handleTokenValidation(token)) {
//     localStorage.clear();
//     store.dispatch(logoutUser());
//     window.location.href = '/login';
//     toast.error('Session Expired');
//   }
// };

// check if jwt token is expired
const validateToken = (token: string) => {
  if (token) {
    const decodedToken = JSON.parse(atob(token.split('.')[1]));

    const currentTimestamp = Date.now();

    if (decodedToken.exp * 1000 < currentTimestamp) {
      store.dispatch(logoutUser());
      window.location.href = '/login';
      toast.error('Session Expired');
    }
  }
};

const getToken = () => {
  const token = store.getState().user.token;

  if (token) {
    validateToken(token);
  }

  return token;
};

const apiRequest = async (
  path: string,
  body?: object | null,
  params?: { [key: string]: string },
  auth?: boolean
) => {
  let data;
  let error;
  let status;
  let headers;

  store.dispatch(startLoading());

  headers = {
    Authorization: `Bearer ${getToken()}`,
    'Access-Control-Allow-Origin': true,
  };

  let requestPath = requests[path] ? requests[path].path : path;

  const method = requests[path]?.method;

  if (params) {
    const urlSearchParams = new URLSearchParams();

    for (const key in params) {
      urlSearchParams.append(key, params[key]);
    }

    requestPath = `${requestPath}?${urlSearchParams
      .toString()
      .replaceAll('%2F', '/')}`;
  }

  try {
    const res = await axios.request({
      baseURL: baseUrl,
      url: requestPath,
      method,
      data: body,
      headers,
    });

    status = res.status;
    data = res.data;
  } catch (err: any) {
    error = err?.response?.data;
  }

  store.dispatch(stopLoading());

  return { data, error, status };
};

export default apiRequest;
